import httpService from '../httpService';
import { ApiResponse } from '../../types/api';

export async function put<T>(url: string, data?: any): Promise<ApiResponse<T>> {
  const response = await httpService.put<ApiResponse<T>>(url, data);
  return response.data;
}
